import React, { createContext, useState } from 'react';

export const DrawerContext = createContext();

const DrawerProvider = ({children})=>{
    const [isOpen,setIsOpen] = React.useState(false);
    const toggleDrawer = (open)=>(e)=>{
        if(e.type === 'keydown' && (e.key === 'Tab'|e.key === 'Shift')) return;
        setIsOpen(open);
    }
    const [theme, setTheme] = useState({            
        mode: "day",
        style: {
            backgroundColor: "white",
            color:"black"
        }
    })
    const toggleTheme = ()=>{
        setTheme({
            mode: theme.mode === "day" ? "night":"day",
            style: theme.mode === "day" ? {
                backgroundColor:"#043154",
                color:"white"
            }: {
                backgroundColor: "white",
                color:"black"
            } 
        })
    }
    const value = {isOpen,setIsOpen,toggleDrawer,theme,toggleTheme};
    return <DrawerContext.Provider value={value}>
        {children}
    </DrawerContext.Provider>
}

export default DrawerProvider;